/**
 * Prefer Prisma `players` over DTO `playerSlots` (empty `playerSlots: []` is truthy).
 */
export function reservationRosterPlayers(reservation: any): any[] {
  const players = reservation?.players;
  if (Array.isArray(players) && players.length > 0) {
    return players;
  }
  const slots = reservation?.playerSlots;
  if (Array.isArray(slots) && slots.length > 0) {
    return slots;
  }
  return [];
}
